// import React from 'react'
// import { RiExchangeDollarFill } from "react-icons/ri";
// import { BsCartX } from "react-icons/bs";
// import { GrCube } from "react-icons/gr";
// import { MdOutlineTrain } from "react-icons/md";
// import { LuClipboardX } from "react-icons/lu";
// import { LuClock } from "react-icons/lu";
// import { LuClipboardCheck } from "react-icons/lu";
// import { RiInbox2Line } from "react-icons/ri";

// const OrderList = () => {
//   return (
//    <div className="page-content">
//   {/* Start Container Fluid */}
//   <div className="container-fluid">
//     {/* ========== Page Title Start ========== */}
//     <div className="row">
//       <div className="col-12">
//         <div className="page-title-box">
//           <h4 className="mb-0 fw-semibold">Orders List</h4>
//           <ol className="breadcrumb mb-0">
//             <li className="breadcrumb-item">
//               <a href="javascript: void(0);">Orders</a>
//             </li>
//             <li className="breadcrumb-item active">Orders List</li>
//           </ol>
//         </div>
//       </div>
//     </div>
//     {/* ========== Page Title End ========== */}
//     <div className="row">
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div>
//                 <h4 className="card-title mb-2">Total Order Received</h4>
//                 <p className="text-muted fw-medium fs-22 mb-0">190</p>
//               </div>
//               <div>
//                 <div className="avatar-md bg-primary bg-opacity-10 rounded">
//                   <RiExchangeDollarFill  className="fs-32 text-primary avatar-title" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div>
//                 <h4 className="card-title mb-2">Order Cancel</h4>
//                 <p className="text-muted fw-medium fs-22 mb-0">241</p>
//               </div>
//               <div>
//                 <div className="avatar-md bg-primary bg-opacity-10 rounded">
//                   <BsCartX  className="fs-32 text-primary avatar-title"/>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div>
//                 <h4 className="card-title mb-2">Order Shipped</h4>
//                 <p className="text-muted fw-medium fs-22 mb-0">630</p>
//               </div>
//               <div>
//                 <div className="avatar-md bg-primary bg-opacity-10 rounded">
//                   <GrCube className="fs-32 text-primary avatar-title" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div>
//                 <h4 className="card-title mb-2">Order Delivered</h4>
//                 <p className="text-muted fw-medium fs-22 mb-0">170</p>
//               </div>
//               <div>
//                 <div className="avatar-md bg-primary bg-opacity-10 rounded">
//                   <MdOutlineTrain className="fs-32 text-primary avatar-title" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div>
//                 <h4 className="card-title mb-2">Repeat Order</h4>
//                 <p className="text-muted fw-medium fs-22 mb-0">210</p>
//               </div>
//               <div>
//                 <div className="avatar-md bg-primary bg-opacity-10 rounded">
//                   <LuClipboardX className="fs-32 text-primary avatar-title" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div>
//                 <h4 className="card-title mb-2">Pending Payment</h4>
//                 <p className="text-muted fw-medium fs-22 mb-0">608</p>
//               </div>
//               <div>
//                 <div className="avatar-md bg-primary bg-opacity-10 rounded">
//                   <LuClock  className="fs-32 text-primary avatar-title"/>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div>
//                 <h4 className="card-title mb-2">Return Orders</h4>
//                 <p className="text-muted fw-medium fs-22 mb-0">200</p>
//               </div>
//               <div>
//                 <div className="avatar-md bg-primary bg-opacity-10 rounded">
//                   <LuClipboardCheck  className="fs-32 text-primary avatar-title"/>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div>
//                 <h4 className="card-title mb-2">In Progress</h4>
//                 <p className="text-muted fw-medium fs-22 mb-0">656</p>
//               </div>
//               <div>
//                 <div className="avatar-md bg-primary bg-opacity-10 rounded">
//                   <RiInbox2Line className="fs-32 text-primary avatar-title"/>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//     <div className="row">
//       <div className="col-xl-12">
//         <div className="card">
//           <div className="d-flex card-header justify-content-between align-items-center">
//             <div>
//               <h4 className="card-title">All Order List</h4>
//             </div>
//             <div className="dropdown">
//               <a
//                 href="#"
//                 className="dropdown-toggle btn btn-sm btn-outline-light rounded"
//                 data-bs-toggle="dropdown"
//                 aria-expanded="false"
//               >
//                 This Month
//               </a>
//               <div className="dropdown-menu dropdown-menu-end">
//                 {/* item*/}
//                 <a href="#!" className="dropdown-item">
//                   Download
//                 </a>
//                 {/* item*/}
//                 <a href="#!" className="dropdown-item">
//                   Export
//                 </a>
//                 {/* item*/}
//                 <a href="#!" className="dropdown-item">
//                   Import
//                 </a>
//               </div>
//             </div>
//           </div>
//           <div className="card-body p-0">
//             <div className="table-responsive">
//               <table className="table align-middle mb-0 table-hover table-centered">
//                 <thead className="bg-light-subtle">
//                   <tr>
//                     <th>Order ID</th>
//                     <th>Created at</th>
//                     <th>Customer</th>
//                     <th>Priority</th>
//                     <th>Total</th>
//                     <th>Payment Status</th>
//                     <th>Items</th>
//                     <th>Delivery Number</th>
//                     <th>Order Status</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td>#583488/80</td>
//                     <td>Apr 23 , 2024</td>
//                     <td>
//                       <a href="#!" className="link-primary fw-medium">
//                         Gail C. Anderson
//                       </a>
//                     </td>
//                     <td> Normal</td>
//                     <td> $1,230.00</td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-light text-dark  px-2 py-1 fs-13">
//                         Unpaid
//                       </span>
//                     </td>
//                     <td> 4</td>
//                     <td> -</td>
//                     <td>
//                       {" "}
//                       <span className="badge border border-secondary text-secondary  px-2 py-1 fs-13">
//                         Draft
//                       </span>
//                     </td>
//                     <td>
//                      <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>#456754/80</td>
//                     <td>Apr 20 , 2024</td>
//                     <td>
//                       <a href="#!" className="link-primary fw-medium">
//                         Jung S. Ayala
//                       </a>
//                     </td>
//                     <td> Normal</td>
//                     <td> $987.00</td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-success text-light  px-2 py-1 fs-13">
//                         Paid
//                       </span>
//                     </td>
//                     <td> 2</td>
//                     <td> -</td>
//                     <td>
//                       {" "}
//                       <span className="badge border border-warning text-warning  px-2 py-1 fs-13">
//                         Packaging
//                       </span>
//                     </td>
//                     <td>
//                      <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>#578246/80</td>
//                     <td>Apr 19 , 2024</td>
//                     <td>
//                       <a href="#!" className="link-primary fw-medium">
//                         David A. Arnold
//                       </a>
//                     </td>
//                     <td> High</td>
//                     <td> $1,478.00</td>
//                     <td>
//                       {" "}
//                       <span className="badge  bg-success text-light px-2 py-1 fs-13">
//                         Paid
//                       </span>
//                     </td>
//                     <td> 5</td>
//                     <td> #D-57837678</td>
//                     <td>
//                       {" "}
//                       <span className="badge border border-success text-success  px-2 py-1 fs-13">
//                         Completed
//                       </span>
//                     </td>
//                     <td>
//                      <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>#348930/80</td>
//                     <td>Apr 04 , 2024</td>
//                     <td>
//                       <a href="#!" className="link-primary fw-medium">
//                         Cecile D. Gordon
//                       </a>
//                     </td>
//                     <td> Normal</td>
//                     <td> $720.00</td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-light text-dark  px-2 py-1 fs-13">
//                         Refund
//                       </span>
//                     </td>
//                     <td> 4</td>
//                     <td> -</td>
//                     <td>
//                       {" "}
//                       <span className="badge border border-danger text-danger  px-2 py-1 fs-13">
//                         Canceled
//                       </span>
//                     </td>
//                     <td>
//                      <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>#391367/80</td>
//                     <td>Apr 02 , 2024</td>
//                     <td>
//                       <a href="#!" className="link-primary fw-medium">
//                         William Moreno
//                       </a>
//                     </td>
//                     <td> Normal</td>
//                     <td> $1,909.00</td>
//                     <td>
//                       <span className="badge  bg-success text-light px-2 py-1 fs-13">
//                         Paid
//                       </span>
//                     </td>
//                     <td> 6</td>
//                     <td> #D-89734235</td>
//                     <td>
//                       {" "}
//                       <span className="badge border border-success text-success  px-2 py-1 fs-13">
//                         Completed
//                       </span>
//                     </td>
//                     <td>
//                      <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>#930447/80</td>
//                     <td>March 28 , 2024</td>
//                     <td>
//                       <a href="#!" className="link-primary fw-medium">
//                         Alphonse Roy
//                       </a>
//                     </td>
//                     <td> High</td>
//                     <td> $879.00</td>
//                     <td>
//                       <span className="badge  bg-success text-light px-2 py-1 fs-13">
//                         Paid
//                       </span>
//                     </td>
//                     <td> 4</td>
//                     <td> #D-35227268</td>
//                     <td>
//                       <span className="badge border border-success text-success  px-2 py-1 fs-13">
//                         Completed
//                       </span>
//                     </td>
//                     <td>
//                      <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>#462397/80</td>
//                     <td>March 20 , 2024</td>
//                     <td>
//                       <a href="#!" className="link-primary fw-medium">
//                         Pierpont Marleau
//                       </a>
//                     </td>
//                     <td> High</td>
//                     <td> $1,230.00</td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-light text-dark  px-2 py-1 fs-13">
//                         Refund
//                       </span>
//                     </td>
//                     <td> 2</td>
//                     <td> -</td>
//                     <td>
//                       {" "}
//                       <span className="badge border border-danger text-danger  px-2 py-1 fs-13">
//                         Canceled
//                       </span>
//                     </td>
//                     <td>
//                      <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>#472356/80</td>
//                     <td>March 12 , 2024</td>
//                     <td>
//                       <a href="#!" className="link-primary fw-medium">
//                         Madeleine Gervais
//                       </a>
//                     </td>
//                     <td> Normal</td>
//                     <td> $1,264.00</td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-success text-light  px-2 py-1 fs-13">
//                         Paid
//                       </span>
//                     </td>
//                     <td> 3</td>
//                     <td> #D-74922656</td>
//                     <td>
//                       {" "}
//                       <span className="badge border border-success text-success  px-2 py-1 fs-13">
//                         Completed
//                       </span>
//                     </td>
//                     <td>
//                      <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>#448226/80</td>
//                     <td>March 02 , 2024</td>
//                     <td>
//                       <a href="#!" className="link-primary fw-medium">
//                         Satordi Gaillou
//                       </a>
//                     </td>
//                     <td> High</td>
//                     <td> $1,787.00</td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-success text-light  px-2 py-1 fs-13">
//                         Paid
//                       </span>
//                     </td>
//                     <td> 4</td>
//                     <td> -</td>
//                     <td>
//                       {" "}
//                       <span className="badge border border-warning text-warning  px-2 py-1 fs-13">
//                         Packaging
//                       </span>
//                     </td>
//                     <td>
//                      <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//             {/* end table-responsive */}
//           </div>
//           <div className="card-footer border-top">
//             <nav aria-label="Page navigation example">
//               <ul className="pagination justify-content-end mb-0">
//                 <li className="page-item">
//                   <a className="page-link" href="javascript:void(0);">
//                     Previous
//                   </a>
//                 </li>
//                 <li className="page-item active">
//                   <a className="page-link" href="javascript:void(0);">
//                     1
//                   </a>
//                 </li>
//                 <li className="page-item">
//                   <a className="page-link" href="javascript:void(0);">
//                     2
//                   </a>
//                 </li>
//                 <li className="page-item">
//                   <a className="page-link" href="javascript:void(0);">
//                     3
//                   </a>
//                 </li>
//                 <li className="page-item">
//                   <a className="page-link" href="javascript:void(0);">
//                     Next
//                   </a>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
//   {/* End Container Fluid */}
//   {/* ========== Footer Start ========== */}
//   <footer className="footer">
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-12 text-center">
//           © Venton. Crafted by{" "}
//           <iconify-icon
//             icon="iconamoon:heart-duotone"
//             className="fs-18 align-middle text-danger"
//           />{" "}
//           <a href="" className="fw-bold footer-text" target="_blank">
//             Techzaa
//           </a>
//         </div>
//       </div>
//     </div>
//   </footer>
//   {/* ========== Footer End ========== */}
// </div>

//   )
// }

// export default OrderList



import React, { useState, useEffect } from 'react';
import { RiExchangeDollarFill } from "react-icons/ri";
import { BsCartX } from "react-icons/bs";
import { GrCube } from "react-icons/gr";
import { MdOutlineTrain } from "react-icons/md";
import { LuClipboardX } from "react-icons/lu";
import { LuClock } from "react-icons/lu";
import { LuClipboardCheck } from "react-icons/lu";
import { RiInbox2Line } from "react-icons/ri";
import { Link } from 'react-router-dom';
import InvoiceDetailPopup from '../Invoice/InvoiceDetail.js';

const OrderList = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortType, setSortType] = useState("ALL");
  const [sortedOrders, setSortedOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Date filter states
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [dateFilterType, setDateFilterType] = useState('all'); // 'all', 'today', 'week', 'month', 'custom'
  const [dateSortOrder, setDateSortOrder] = useState('desc'); // 'asc' or 'desc'

  // Invoice Modal States
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);

  const [stats, setStats] = useState({
    totalReceived: 0,
    cancelled: 0,
    shipped: 0,
    delivered: 0,
    repeat: 0,
    pendingPayment: 0,
    returned: 0,
    abandoned: 0,
    inProgress: 0
  });

  const getItemStatus = (order, key) => {
  if (!order.items || order.items.length === 0) return "";
  return order.items[0][key] || "";
};


  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [orders, sortType, startDate, endDate, dateFilterType, dateSortOrder]);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_place_order');
      const result = await response.json();

      if (result.status && result.data) {
        setOrders(result.data);
      } else {
        setError('No data found');
      }
    } catch (err) {
      setError('Failed to fetch orders');
      console.error('Error fetching orders:', err);
    } finally {
      setLoading(false);
    }
  };

  const calculateStats = (ordersData) => {
  const stats = {
    totalReceived: ordersData.length,

    cancelled: ordersData.filter(
      o => normalizeStatus(getItemStatus(o, "order_status")) === "cancel"
    ).length,

    shipped: ordersData.filter(
      o => normalizeStatus(getItemStatus(o, "order_status")) === "shipped"
    ).length,

    delivered: ordersData.filter(
      o => normalizeStatus(getItemStatus(o, "order_status")) === "delivered"
    ).length,

    pendingPayment: ordersData.filter(
      o => normalizeStatus(getItemStatus(o, "payment_status")) === "pending"
    ).length,

    returned: ordersData.filter(
      o => normalizeStatus(getItemStatus(o, "order_status")) === "return"
    ).length,

    abandoned: ordersData.filter(
      o => normalizeStatus(getItemStatus(o, "order_status")) === "abandoned"
    ).length,

    inProgress: ordersData.filter(
      o =>
        ["processing", "confirmed"].includes(
          normalizeStatus(getItemStatus(o, "order_status"))
        )
    ).length,

    repeat: 0
  };

  setStats(stats);
};


  const normalizeStatus = (value) => {
    if (!value) return "";
    return value.toString().trim().toLowerCase();
  };

  const filterByDateRange = (ordersData) => {
    if (dateFilterType === 'all') {
      return ordersData;
    }

    const now = new Date();
    let start, end;

    switch (dateFilterType) {
      case 'today':
        start = new Date(now.setHours(0, 0, 0, 0));
        end = new Date(now.setHours(23, 59, 59, 999));
        break;
      
      case 'week':
        start = new Date(now.setDate(now.getDate() - 7));
        end = new Date();
        break;
      
      case 'month':
        start = new Date(now.setMonth(now.getMonth() - 1));
        end = new Date();
        break;
      
      case 'custom':
        if (!startDate || !endDate) return ordersData;
        start = new Date(startDate);
        end = new Date(endDate);
        end.setHours(23, 59, 59, 999);
        break;
      
      default:
        return ordersData;
    }

    return ordersData.filter(order => {
      const orderDate = new Date(order.created_at);
      return orderDate >= start && orderDate <= end;
    });
  };

  const applyFilters = () => {
    let filtered = [...orders];

    // Apply status filter
    switch (sortType) {
      case "CANCELLED":
        filtered = filtered.filter(o => normalizeStatus(o.order_status) === "cancel");
        break;
      case "SHIPPED":
        filtered = filtered.filter(o => normalizeStatus(o.order_status) === "shipped");
        break;
      case "DELIVERED":
        filtered = filtered.filter(o => normalizeStatus(o.order_status) === "delivered");
        break;
      case "PENDING_PAYMENT":
        filtered = filtered.filter(
  o => normalizeStatus(getItemStatus(o, "payment_status")) === "pending"
);

        break;
      case "RETURNED":
        filtered = filtered.filter(o => normalizeStatus(o.order_status) === "return");
        break;
      case "ABANDONED":
        filtered = filtered.filter(o => normalizeStatus(o.order_status) === "abandoned");
        break;
      case "IN_PROGRESS":
        filtered = filtered.filter(o =>
          normalizeStatus(o.order_status) === "processing" ||
          normalizeStatus(o.order_status) === "confirmed"
        );
        break;
      default:
        break;
    }

    // Apply date filter
    filtered = filterByDateRange(filtered);

    // Apply date sorting
    filtered = sortByDate(filtered);

    setSortedOrders(filtered);
    calculateStats(filtered);
    setCurrentPage(1);
  };

  const sortByDate = (ordersData) => {
    return [...ordersData].sort((a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      
      if (dateSortOrder === 'asc') {
        return dateA - dateB; // Oldest first
      } else {
        return dateB - dateA; // Newest first
      }
    });
  };

  const toggleDateSort = () => {
    setDateSortOrder(prev => prev === 'asc' ? 'desc' : 'asc');
  };

  const handleDateFilterChange = (type) => {
    setDateFilterType(type);
    if (type !== 'custom') {
      setStartDate('');
      setEndDate('');
    }
  };

  const handleCustomDateFilter = () => {
    if (startDate && endDate) {
      setDateFilterType('custom');
    }
  };

  const clearDateFilter = () => {
    setDateFilterType('all');
    setStartDate('');
    setEndDate('');
  };

  const getOrderStatusBadge = (status) => {
    const s = normalizeStatus(status);

    if (s === "delivered") {
      return "badge border border-success text-success";
    }
    if (s === "pending") {
      return "badge border border-secondary text-secondary";
    }
    if (s === "processing" || s === "confirmed") {
      return "badge border border-warning text-warning";
    }
    if (s === "cancel") {
      return "badge border border-danger text-danger";
    }
    if (s === "return") {
      return "badge border border-info text-info";
    }
    if (s === "abandoned") {
      return "badge border border-danger text-danger";
    }
    return "badge border border-dark text-dark";
  };

  const getPaymentStatusBadge = (status) => {
    const statusLower = status.toLowerCase();
    if (statusLower === 'paid' || statusLower === 'completed') {
      return 'badge bg-success text-light px-2 py-1 fs-13';
    } else if (statusLower === 'pending') {
      return 'badge bg-light text-dark px-2 py-1 fs-13';
    } else if (statusLower === 'refund') {
      return 'badge bg-light text-dark px-2 py-1 fs-13';
    } else if (statusLower === 'abandoned') {
      return 'badge bg-light text-dark px-2 py-1 fs-13';
    }
    return 'badge bg-secondary text-light px-2 py-1 fs-13';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleSort = (type) => {
    setSortType(type);
  };

  const handleShowInvoice = (orderId) => {
    setSelectedOrderId(orderId);
    setShowInvoiceModal(true);
  };

  const handleCloseInvoice = () => {
    setShowInvoiceModal(false);
    setSelectedOrderId(null);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentOrders = sortedOrders.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(sortedOrders.length / itemsPerPage);

  const getPageNumbers = () => {
    const pages = [];
    let startPage = Math.max(1, currentPage - 1);
    let endPage = Math.min(totalPages, currentPage + 1);

    if (currentPage === 1) {
      endPage = Math.min(3, totalPages);
    }

    if (currentPage === totalPages) {
      startPage = Math.max(totalPages - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Orders List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Orders</a>
                </li>
                <li className="breadcrumb-item active">Orders List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Date Filter Section */}
        <div className="row mb-3">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="row g-3 align-items-end">
                  <div className="col-md-3">
                    <label className="form-label">Quick Date Filter</label>
                    <div className="btn-group w-100" role="group">
                      <button
                        type="button"
                        className={`btn btn-sm ${dateFilterType === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => handleDateFilterChange('all')}
                      >
                        All
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm ${dateFilterType === 'today' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => handleDateFilterChange('today')}
                      >
                        Today
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm ${dateFilterType === 'week' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => handleDateFilterChange('week')}
                      >
                        Last 7 Days
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm ${dateFilterType === 'month' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => handleDateFilterChange('month')}
                      >
                        Last 30 Days
                      </button>
                    </div>
                  </div>
                  
                  <div className="col-md-2">
                    <label className="form-label">Sort by Date</label>
                    <button
                      className="btn btn-outline-secondary w-100"
                      onClick={toggleDateSort}
                    >
                      <i className={`fa-solid fa-arrow-${dateSortOrder === 'desc' ? 'down' : 'up'} me-2`}></i>
                      {dateSortOrder === 'desc' ? 'Newest First' : 'Oldest First'}
                    </button>
                  </div>
                  
                  <div className="col-md-2">
                    <label htmlFor="startDate" className="form-label">Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      id="startDate"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  
                  <div className="col-md-2">
                    <label htmlFor="endDate" className="form-label">End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      id="endDate"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                  
                  <div className="col-md-3">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleCustomDateFilter}
                      disabled={!startDate || !endDate}
                    >
                      <i className="fa-solid fa-filter me-1"></i>
                      Apply Custom Range
                    </button>
                    {(dateFilterType !== 'all' || startDate || endDate) && (
                      <button
                        className="btn btn-outline-secondary"
                        onClick={clearDateFilter}
                      >
                        <i className="fa-solid fa-times me-1"></i>
                        Clear
                      </button>
                    )}
                  </div>
                </div>
                
                {dateFilterType !== 'all' && (
                  <div className="mt-2">
                    <small className="text-muted">
                      <i className="fa-solid fa-info-circle me-1"></i>
                      Showing orders from: <strong>
                        {dateFilterType === 'today' && 'Today'}
                        {dateFilterType === 'week' && 'Last 7 days'}
                        {dateFilterType === 'month' && 'Last 30 days'}
                        {dateFilterType === 'custom' && startDate && endDate && 
                          `${formatDate(startDate)} to ${formatDate(endDate)}`}
                      </strong>
                    </small>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="row">
          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="card-title mb-2">Total Order Received</h4>
                    <p className="text-muted fw-medium fs-22 mb-0">{stats.totalReceived}</p>
                  </div>
                  <div>
                    <div className="avatar-md bg-primary bg-opacity-10 rounded">
                      <RiExchangeDollarFill className="fs-32 text-primary avatar-title" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="card-title mb-2">Order Cancel</h4>
                    <p className="text-muted fw-medium fs-22 mb-0">{stats.cancelled}</p>
                  </div>
                  <div>
                    <div className="avatar-md bg-primary bg-opacity-10 rounded">
                      <BsCartX className="fs-32 text-primary avatar-title" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="card-title mb-2">Order Shipped</h4>
                    <p className="text-muted fw-medium fs-22 mb-0">{stats.shipped}</p>
                  </div>
                  <div>
                    <div className="avatar-md bg-primary bg-opacity-10 rounded">
                      <GrCube className="fs-32 text-primary avatar-title" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="card-title mb-2">Order Delivered</h4>
                    <p className="text-muted fw-medium fs-22 mb-0">{stats.delivered}</p>
                  </div>
                  <div>
                    <div className="avatar-md bg-primary bg-opacity-10 rounded">
                      <MdOutlineTrain className="fs-32 text-primary avatar-title" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="card-title mb-2">Repeat Order</h4>
                    <p className="text-muted fw-medium fs-22 mb-0">{stats.repeat}</p>
                  </div>
                  <div>
                    <div className="avatar-md bg-primary bg-opacity-10 rounded">
                      <LuClipboardX className="fs-32 text-primary avatar-title" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="card-title mb-2">Pending Payment</h4>
                    <p className="text-muted fw-medium fs-22 mb-0">{stats.pendingPayment}</p>
                  </div>
                  <div>
                    <div className="avatar-md bg-primary bg-opacity-10 rounded">
                      <LuClock className="fs-32 text-primary avatar-title" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="card-title mb-2">Return Orders</h4>
                    <p className="text-muted fw-medium fs-22 mb-0">{stats.returned}</p>
                  </div>
                  <div>
                    <div className="avatar-md bg-primary bg-opacity-10 rounded">
                      <LuClipboardCheck className="fs-32 text-primary avatar-title" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="card-title mb-2">In Progress</h4>
                    <p className="text-muted fw-medium fs-22 mb-0">{stats.inProgress}</p>
                  </div>
                  <div>
                    <div className="avatar-md bg-primary bg-opacity-10 rounded">
                      <RiInbox2Line className="fs-32 text-primary avatar-title" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="card-title mb-2">Abandoned Orders</h4>
                    <p className="text-muted fw-medium fs-22 mb-0">{stats.abandoned}</p>
                  </div>
                  <div>
                    <div className="avatar-md bg-primary bg-opacity-10 rounded">
                      <RiInbox2Line className="fs-32 text-primary avatar-title" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Orders Table */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="d-flex card-header justify-content-between align-items-center">
                <div>
                  <h4 className="card-title">All Order List</h4>
                </div>
                <div className="dropdown">
                  <a href="#" className="dropdown-toggle btn btn-sm btn-outline-light rounded" data-bs-toggle="dropdown">
                    Sort Orders
                  </a>
                  <div className="dropdown-menu dropdown-menu-end">
                    <button className="dropdown-item" onClick={() => handleSort("TOTAL")}>Total Order Received</button>
                    <button className="dropdown-item" onClick={() => handleSort("CANCELLED")}>Order Cancel</button>
                    <button className="dropdown-item" onClick={() => handleSort("SHIPPED")}>Order Shipped</button>
                    <button className="dropdown-item" onClick={() => handleSort("DELIVERED")}>Order Delivered</button>
                    <button className="dropdown-item" onClick={() => handleSort("PENDING_PAYMENT")}>Pending Payment</button>
                    <button className="dropdown-item" onClick={() => handleSort("RETURNED")}>Return Orders</button>
                    <button className="dropdown-item" onClick={() => handleSort("IN_PROGRESS")}>In Progress</button>
                    <button className="dropdown-item" onClick={() => handleSort("ABANDONED")}>Abandoned Orders</button>
                  </div>
                </div>
                <div className="dropdown">
                  <a href="#" className="dropdown-toggle btn btn-sm btn-outline-light rounded" data-bs-toggle="dropdown" aria-expanded="false">
                    This Month
                  </a>
                  <div className="dropdown-menu dropdown-menu-end">
                    <a href="#!" className="dropdown-item">Download</a>
                    <a href="#!" className="dropdown-item">Export</a>
                    <a href="#!" className="dropdown-item">Import</a>
                  </div>
                </div>
              </div>

              <div className="card-body p-0">
                {loading ? (
                  <div className="text-center p-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : error ? (
                  <div className="alert alert-danger m-3" role="alert">
                    {error}
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table align-middle mb-0 table-hover table-centered">
                      <thead className="bg-light-subtle">
                        <tr>
                          <th>Order ID</th>
                          <th>Created at</th>
                          <th>Customer</th>
                          <th>Product</th>
                          <th>Total</th>
                          <th>Payment Status</th>
                          <th>Payment Mode</th>
                          <th>Items</th>
                          <th>Order Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentOrders.length > 0 ? (
                          currentOrders.map((order) => (
                            <tr key={order.order_id}>
                              <td>#{order.order_number}</td>
                              <td>{formatDate(order.created_at)}</td>
                              <td>{order.contact_name}</td>
                              <td>{order.product_name}</td>
                              <td>₹{parseFloat(order.total).toFixed(2)}</td>
                              <td>
                               <span className={getPaymentStatusBadge(getItemStatus(order, "payment_status"))}>
  {getItemStatus(order, "payment_status")}
</span>
                              </td>
                              <td>{getItemStatus(order, "payment_mode")}</td>
                              <td>{order.qty}</td>
                              <td>
                                <span className={getOrderStatusBadge(getItemStatus(order, "order_status"))}>
  {getItemStatus(order, "order_status")}
</span>
                              </td>
                              <td>
                                <div className="d-flex gap-2">
                                  <button
                                    onClick={() => handleShowInvoice(order.order_id)}
                                    className="btn btn-soft-success btn-sm"
                                    title="View Invoice"
                                  >
                                    <i className="fa-solid fa-file-invoice align-middle fs-18"></i>
                                  </button>
                                  <Link to={`/order-list-edit/${order.order_id}`} className="btn btn-soft-primary btn-sm">
                                    <i className="fa-solid fa-pencil align-middle fs-18"></i>
                                  </Link>
                                  <Link className="btn btn-soft-danger btn-sm">
                                    <i className="fa-solid fa-trash align-middle fs-18"></i>
                                  </Link>
                                  <Link
                                    to={`/order-detail-view/${order.order_id}`}
                                    className="btn btn-light btn-sm"
                                  >
                                    <i className="fa-solid fa-eye fs-18"></i>
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center py-4">
                              No orders found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              <div className="card-footer border-top">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-end mb-0">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button className="page-link" onClick={handlePrev}>Previous</button>
                    </li>
                    {getPageNumbers().map((page) => (
                      <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                        <button className="page-link" onClick={() => handlePageChange(page)}>{page}</button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <button className="page-link" onClick={handleNext}>Next</button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Invoice Detail Popup */}
      <InvoiceDetailPopup
        show={showInvoiceModal}
        onClose={handleCloseInvoice}
        orderId={selectedOrderId}
      />

      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon icon="iconamoon:heart-duotone" className="fs-18 align-middle text-danger" />{" "}
              <a href="" className="fw-bold footer-text" target="_blank">Techzaa</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default OrderList;